import React from "react";
import ReactDOM from "react-dom/client";
import "../src/css/index.css";
import '../src/css/components.css';
import '../src/css/dataTable.css';

import "primeicons/primeicons.css";
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(<App />);
